export enum ReasonCodes {
    //User, link, offer reasons
    INVALID_USER="INVALID_USER",
    INVALID_LINK="INVALID_LINK",
    INVALID_OFFER="INVALID_OFFER",
    UNAUTHORIZED="UNAUTHORIZED",

    INVALID_TAX_NR="INVALID_TAX_NR",

    //Group reasons
    INVALID_GROUP="INVALID_GROUP",
    USER_ALREADY_MEMBER="USER_ALREADY_MEMBER",
    USER_DOESNT_OWN_GROUP="USER_DOESNT_OWN_GROUP",
    GROUP_HAS_NO_INVITE="GROUP_HAS_NO_INVITE",
    GROUP_HAS_MISSING_PRODUCT="GROUP_HAS_MISSING_PRODUCT",

    //Product reasons
    USER_DOESNT_OWN_PRODUCT="USER_DOESNT_OWN_PRODUCT",
}

export enum ApiResultTypes {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
}